import { z } from 'zod';

export const AnswerSettingSchema = z.object({
  hasCorrectAnswer: z.boolean(),
});
export type AnswerSetting = z.infer<typeof AnswerSettingSchema>;
